<template>
  <div>
    <v-layout
      align-center
      column
      justify-center
    >
      <v-flex
        class="title bg"
        xs7
      >
        <h1 class="pa-3">
          This is an about page
        </h1>
        <div class="pa-3">
          <p>
            Oops, it's seems that this page was not remove in production... Well
            there is nothing here.
          </p>
          <p>Or maybe not...</p>
          <p>
            This game app was made with Vue.js and Vuetify for a project at
            Ubiqum Barcelona.
          </p>
          <p>
            I hope that by the time you read this message I already refactored
            and optimised the code of this client app, because honestly it is a
            mess.
          </p>
          <p>
            Well, I hope you enjoyed the game. Even if it's basic and super
            slow, I have a lot of fun and good (and hysterical) times making it.
          </p>
          <p>Antoine M.</p>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
    name: "AboutView"
}
</script>

<style scoped>
.bg {
    background-color: rgba(40, 47, 68, 0.671);
}
</style>
